// src/App.tsx
import Router from "./Router";
import { SupabaseProvider } from "./components/SupabaseProvider";
import { GTMProvider } from "./components/tracking";
import { ErrorBoundary } from "./components/tracking/ErrorBoundary";
import { useEffect } from 'react';
import { unifiedEventDispatcher } from './tracking/gtm/services/unified-event-dispatcher';

window.dataLayer = window.dataLayer || [];
window.pageViewCount = 0;

function AppContent() {
  useEffect(() => {
    unifiedEventDispatcher.pushUnifiedEvent('app_init', {
      eventParams: {
        pageType: 'app_init'
      }
    });
  }, []);

  return <Router />;
}

function App() {
  return (
    <SupabaseProvider>
      <ErrorBoundary>
        <GTMProvider>
          <AppContent />
        </GTMProvider>
      </ErrorBoundary>
    </SupabaseProvider>
  );
}

export default App;
